import { Modal } from 'common/Modal/Modal'
import { Button } from 'components/Button/Button'
import { useState } from 'react'
import { createRoot } from 'react-dom/client'
import Styles from './ConfirmModal.module.scss'

interface Props {
  onConfirm: () => void
  onCancel?: () => void
  title: string
  cancelText: string
  confirmText: string
  prompt: string
  confirmButton?: React.ReactNode
}

export const ConfirmModal = ({ onConfirm, onCancel, title, cancelText, confirmText, prompt, confirmButton }: Props) => {
  const [modalOpen, setModalOpen] = useState(true)
  if (!modalOpen) return null

  const handleCancel = () => {
    setModalOpen(false)
    if (onCancel) onCancel()
  }

  const handleConfirm = () => {
    setModalOpen(false)
    onConfirm()
  }

  return (
    <Modal show={modalOpen} title={title} onClose={handleCancel}>
      <>
        <div className={Styles.prompt}>{prompt}</div>

        <div className={Styles.buttonsContainer}>
          <Button autoFocus size="md" variant="tertiary" onPress={handleCancel} data-testid="confirmModalCancelButton">
            {cancelText}
          </Button>
          <Button
            className={Styles.confirmButton}
            size="md"
            onPress={handleConfirm}
            data-testid="confirmModalConfirmButton"
          >
            {confirmText}
          </Button>
        </div>
      </>
    </Modal>
  )
}

export const attachConfirmModalToDom = ({ title, onConfirm, onCancel, cancelText, confirmText, prompt }: Props) => {
  const container = document.createElement('div')
  document.body.appendChild(container)
  const root = createRoot(container)
  root.render(
    <ConfirmModal
      title={title}
      onConfirm={onConfirm}
      onCancel={onCancel}
      cancelText={cancelText}
      confirmText={confirmText}
      prompt={prompt}
    />,
  )
}
